import React, { Component, Fragment } from "react";
import "./Site.css";
import {
  Row,
  Col,
  Button,
  Table,
  ButtonGroup,
  Badge,
  ButtonDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Input,
  Label
} from "reactstrap";
import Select from "react-select";
import Alert from "react-s-alert";
import _ from "lodash";
import './Site.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { api, filterHelper, uiHelper, constant } from "../helpers";
import { TextFilter, SelectFilter, FilterSet, ActiveToggleFilter, Pager } from "../components";
import { Link } from "react-router-dom";
import classnames from "classnames";

export default class COARequestProductLog extends Component {
    static displayName = COARequestProductLog.name;
    constructor(props) {
      super(props);
      this.state = {
        filters: [],
        pagedList: null,
        sortColumn: "Name",
        sortAscending: true,
        dropdownOpen: false,
      };
  
      this.refreshList = this.refreshList.bind(this);
      this.clearFilters = this.clearFilters.bind(this);
      this.onChangeFilter = this.onChangeFilter.bind(this);
      this.setPage = this.setPage.bind(this);
      this.onDismiss = this.onDismiss.bind(this);
      this.toggle = this.toggle.bind(this);
    }
      componentDidMount() {
        this.refreshList();
    }
  
    refreshList(sortColumn, sortAscending, filters, pageNumber) {
      const resolvedFilters = filters || this.state.filters;
      const resolvedSort = {
        sortColumn: sortColumn || this.state.sortColumn,
        sortAscending: sortAscending || this.state.sortAscending
      };
      const payload = {
        activeOnly: null,
        name: null,
        ...resolvedSort,
        ...filterHelper.filtersToObject(resolvedFilters),
        pageSize: 50,
        page: pageNumber || (this.state.pagedList ? this.state.pagedList.pageNumber : 1)
      };
      api.post("COA/COARequestProductLogs", payload)
        .then(response => {
          if (response.data) {
            let list = _.map(response.data.dataSource, l => {
              l.editing = false;
              l.part = uiHelper.resolveValue(null, l.partId, l.partName);
              return l;
            });
            
            this.setState({
              ...resolvedSort,
              pagedList: {
                list: list,
                pageNumber: response.data.page,
                pageSize: response.data.pageSize,
                totalItems: response.data.totalItems,
                totalPages: response.data.totalPages
              },
              filters: resolvedFilters,
            });
          }
        })
    }
  
    setPage(page) {
      this.refreshList(null, null, null, page);
    }
  
    clearFilters() {
      const filters = [];
      this.setState({ filters: filters });
      this.refreshList(null, null, filters);
    }
  
    onChangeFilter(changedFilter) {
      const filters = filterHelper.getFilters(
        this.state.filters,
        changedFilter
      );
      this.setState({ filters: filters },
        () => { this.refreshList(null, null, filters, 1) }
      );
    }
  
    onDismiss() {
        this.setState({
            isMessageVisible: !this.state.isMessageVisible,
            message: null,
            messageColor: null,
        });
    }
    toggle(toggleName) {
        this.setState({ [toggleName]: !this.state[toggleName] });
    }


    render() {
      return (
        <div className="ml-4 mr-4">
          <Row className={"p-2"}>
            <Col>
                <h4>Request Product Log</h4>
            </Col>
          </Row>
          <Row className="rowSpacing cursor">
            <Col>
              <FilterSet filters={this.state.filters} clearFilters={this.clearFilters} childrenClassName="pt-2 cursor pl-1 pr-1">
                <Col xs="3">
                  <TextFilter
                    filterName="name"
                    displayName=" Name"
                    descriptionPrefix="contains"
                    onChangeCallback={this.onChangeFilter}
                  />
                </Col>
                {/*<Col xs="3">*/}
                {/*  <SelectFilter*/}
                {/*      filterName ="partId"*/}
                {/*      displayName="CBDMD Ingredient"*/}
                {/*      onChangeCallback={this.onChangeFilter}*/}
                {/*      isSingleSelect={true}*/}
                {/*      options={this.state.partList}*/}
                {/*      values={filterHelper.get_value("partId")}*/}
                {/*      />*/}
                {/*</Col>*/}
                <Col xs="3">
                  <ActiveToggleFilter
                    filterName="activeOnly"
                    displayName="Active Only"
                    onChangeCallback={this.onChangeFilter}
                    value={filterHelper.get_value(
                    "activeOnly",
                    this.state.filters
                    )}
                  />
                </Col>
              </FilterSet>
            </Col>
          </Row>
  
          <Row className="d-flex flex-row mt-2">
            <Col>
              <Table size="sm" responsive>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.pagedList && this.state.pagedList.list.length > 0 ? (
                    this.state.pagedList.list.map(e => (
                      <tr key={e.id}>
                        {e.editing ? (
                          <Fragment>
                            <td>
                              <Input 
                                type="text" 
                                maxLength="60" 
                                name="name" 
                                id="name" 
                                onChange={(ev) => this.onInputChange(ev, e.id, "name")} 
                                value={e.name} 
                              />
                            </td>
                            <td>
                              <ButtonGroup>
                                <Button className={"cbdmdSecondary buttonGroupSpacing"} size="sm" title={"Cancel Edit"} onClick={() => this.onCancelEdit(e.id)}>
                                  <FontAwesomeIcon icon="reply" />
                                </Button>
                                <Button className={"cbdmdPrimary buttonGroupSpacing"} size="sm" title={"Save Details"} onClick={() => this.onSave(e.id)}>
                                  <FontAwesomeIcon icon="save" />
                                </Button>
                              </ButtonGroup>
                            </td>
                          </Fragment>
                        ) : (
                          <Fragment>
                            <td>{e.name}</td>
                            <td>
                              {e.deactivatedAt === null
                              ? <ButtonGroup>
                                  <Button className={"cbdmdPrimary buttonGroupSpacing"} size="sm" title={"Edit Details"} onClick={() => this.onEdit(e.id)}>
                                    <FontAwesomeIcon icon="edit" />
                                  </Button>
                                  <Button size="sm" className="cbdmdDanger buttonGroupSpacing" onClick={() => this.onDelete(e.id)} title="Delete">
                                    <FontAwesomeIcon
                                      icon="trash-alt"
                                      className="ml-1 mt-0 mb-0 mr-1 pointer "
                                      title="Delete"
                                    />
                                  </Button>
                                </ButtonGroup>
                              : <Button size="sm" className="cbdmdInfo buttonGroupSpacing" onClick={() => this.onRevive(e.id)} title="Delete">
                                  <FontAwesomeIcon
                                    icon="recycle"
                                    className="ml-1 mt-0 mb-0 mr-1 pointer "
                                    title="Recycle"
                                  />
                                </Button>}
                            </td>
                          </Fragment>
                        )}
                      </tr>
                    ))) : (<tr>
                        <td>
                            No Records available
                        </td>
                    </tr>)}
                </tbody>
              </Table>
              <Pager {...this.state.pagedList} callBack={this.setPage} />
            </Col>
          </Row>
        </div>
      );
    }
}


// WEBPACK FOOTER //
// ./src/components/COARequestProductLog.js